<template>
  <div class="IOContextMenu">
    <v-menu
      v-model="show"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      :rounded="'lg'"
    >
      <v-list>
        <v-list-item
          dense
          v-for="(item, index) in contextMenuItems"
          :key="index"
          @click="onClickContextMenu(item.id)"
        >
          <v-icon small :color="item.color" class="px-1">
            {{ item.icon }}
          </v-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import TextUtils from "../../utils/TextUtils";

export default {
  props: {
    x: Number,
    y: Number,
  },
  data() {
    return {
      show: false,
      contextMenuItems: [],
      item: null,
    };
  },
  mounted() {
    this.getContextMenuItems();
  },
  methods: {
    showMenu(item) {
      this.item = item;
      this.show = true;
    },
    hideMenu() {
      this.show = false;
    },
    getContextMenuItems() {
      const permissions = this.$store.state.permission.permissionList;
      const items = [
        {
          id: "vacation",
          title: this.$t("nav-request-leave"),
          icon: "mdi-calendar-weekend",
          color: "green",
          permissionId: 1,
        },
        {
          id: "mission",
          title: this.$t("nav-request-mission"),
          icon: "mdi-bag-checked",
          color: "brown",
          permissionId: 2,
        },
        {
          id: "io",
          title: this.$t("nav-request-io"),
          icon: "mdi-transit-transfer",
          color: "blue",
          permissionId: 3,
        },
        {
          id: "extrawork",
          title: this.$t("nav-request-extra-work"),
          icon: "mdi-sort-clock-descending-outline",
          color: "red",
          permissionId: 4,
        },
      ];
      this.contextMenuItems = items.filter(item =>
        permissions.includes(item.permissionId)
      );
    },
    onClickContextMenu(id) {
      const sd = TextUtils.convertToEnglishDigits(this.item?.beginDate || this.item?.endDate);
      console.log("sd", sd);
      console.log("onClickContextMenu", this.item);
      const routes = {
        vacation: "request-leave",
        mission: "request-mission",
        io: "request-io",
        extrawork: "request-extra-work",
      };
      const routeName = routes[id];
      if (routeName) {
        this.$router.push({ name: routeName, query: { SD: sd } });
      }
    },
  },
};
</script>
